<div class="velocity-spectra-wrapper">
    <div class="row">

        <div class="col-lg-8 col-md-12">

            <div class="chart-section mb-5">
                <div class="chart-header">
                    <h3 class="chart-title">Velocity Amplitude Spectra</h3>
                </div>

                <div class="chart-wrapper-border">
                    <div *ngIf="loadingVelocityAmplitude" class="skeleton-loader chart-skeleton">
                        <div class="skeleton-rect graph-area"></div>
                    </div>

                    <div *ngIf="!loadingVelocityAmplitude && canvasDataSeries.length > 0" class="chart-container">
                        <app-spectra-chart [dataSeries]="canvasDataSeries" titleX="Frequency (Hz)"
                            titleY="Velocity (mm/s)">
                        </app-spectra-chart>
                    </div>

                    <div *ngIf="!loadingVelocityAmplitude && canvasDataSeries.length === 0" class="no-data-state">
                        No Velocity Data Available
                    </div>
                </div>
            </div>

            <div class="chart-section">
                <div class="chart-header">
                    <h3 class="chart-title">Velocity Acceleration Spectra</h3>
                </div>

                <div class="chart-wrapper-border">
                    <div *ngIf="loadingVelocityAcceleration" class="skeleton-loader chart-skeleton">
                        <div class="skeleton-rect graph-area"></div>
                    </div>

                    <div *ngIf="!loadingVelocityAcceleration && canvasAccelerationSeries.length > 0"
                        class="chart-container">
                        <app-spectra-chart [dataSeries]="canvasAccelerationSeries" titleX="Sample Count"
                            titleY="Acceleration (m/sec²)">
                        </app-spectra-chart>
                    </div>

                    <div *ngIf="!loadingVelocityAcceleration && canvasAccelerationSeries.length === 0"
                        class="no-data-state">
                        No Acceleration Data Available
                    </div>
                </div>
            </div>

        </div>

        <div class="col-lg-4 col-md-12 border-start-lg">

            <div class="table-section mb-5">
                <h5 class="section-title">Crest Factor</h5>

                <div class="table-responsive">
                    <table class="table table-bordered custom-table">
                        <thead>
                            <tr>
                                <th>Radial</th>
                                <th>Tangential</th>
                                <th>Axial</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="loadingCrestFactor">
                                <td>
                                    <div class="skeleton-cell"></div>
                                </td>
                                <td>
                                    <div class="skeleton-cell"></div>
                                </td>
                                <td>
                                    <div class="skeleton-cell"></div>
                                </td>
                            </tr>

                            <tr *ngIf="!loadingCrestFactor && crestFactorData">
                                <td>{{ crestFactorData.xcf | number:'1.2-2' }}</td>
                                <td>{{ crestFactorData.ycf | number:'1.2-2' }}</td>
                                <td>{{ crestFactorData.zcf | number:'1.2-2' }}</td>
                            </tr>

                            <tr *ngIf="!loadingCrestFactor && !crestFactorData">
                                <td colspan="3" class="text-center text-muted small">No Data</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="table-section">
                <h5 class="section-title">Predominant Frequency</h5>

                <div class="table-responsive freq-table-container">
                    <table class="table table-bordered table-striped custom-table small-text">
                        <thead>
                            <tr>
                                <th>Frequency (Hz)</th>
                                <th>Radial</th>
                                <th>Tangential</th>
                                <th>Axial</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="loadingPredominantFrequency">
                                <tr *ngFor="let i of [1,2,3,4,5,6]">
                                    <td>
                                        <div class="skeleton-cell"></div>
                                    </td>
                                    <td>
                                        <div class="skeleton-cell"></div>
                                    </td>
                                    <td>
                                        <div class="skeleton-cell"></div>
                                    </td>
                                    <td>
                                        <div class="skeleton-cell"></div>
                                    </td>
                                </tr>
                            </ng-container>

                            <ng-container *ngIf="!loadingPredominantFrequency && predominantFrequencyData.length > 0">
                                <tr *ngFor="let item of predominantFrequencyData">
                                    <td>{{ item.freq | number:'1.2-2' }}</td>
                                    <td>{{ item['Acceleration 1 X'] !== '-' ? (item['Acceleration 1 X'] |
                                        number:'1.2-2') : '-' }}</td>
                                    <td>{{ item['Acceleration 1 Y'] !== '-' ? (item['Acceleration 1 Y'] |
                                        number:'1.2-2') : '-' }}</td>
                                    <td>{{ item['Acceleration 1 Z'] !== '-' ? (item['Acceleration 1 Z'] |
                                        number:'1.2-2') : '-' }}</td>
                                </tr>
                            </ng-container>

                            <tr *ngIf="!loadingPredominantFrequency && predominantFrequencyData.length === 0">
                                <td colspan="4" class="text-center text-muted small py-3">No Predominant Frequency Data
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>

    </div>
</div>